// What we offer. One entry per tile on the home page and per /services/:slug page.
// `interest` matches ProjectInquiry::INTERESTS so "Start a project" can be preselected.

export type Service = {
    slug: string;
    title: string;
    tagline: string;
    iconName: 'Scan' | 'Camera' | 'Zap' | 'Globe' | 'Layers' | 'Brain' | 'Radio' | 'Lightbulb' | 'Move3d' | 'Aperture';
    interest: string;
    image: string;
    summary: string;
    whatWeDo: string[];
    deliverables: string[];
    gearTags: string[];      // featured rental items, by asset tag
    goodFor: string[];
    process: string[];
};

import services from "../../config/services.json";

export const SERVICES = services as Service[];

export const serviceBySlug = (slug: string) => SERVICES.find((s) => s.slug === slug);
